var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{attrs:{"action":"export","type":"fill","name":_vm.name,"noMargin":true},on:{"export":_vm.exportData}})}
var staticRenderFns = []

export { render, staticRenderFns }